import { useContext } from 'react';
import { ToolsContext } from '../../ToolsContext.js';
import { MapContainer, TileLayer } from 'react-leaflet'
import { MapContextMenu } from './MapContextMenu.js';
import { MarkerStopLayer } from './MarkerStopLayer.js';
import { RoutePolylineLayer } from './RoutePolylineLayer.js';
import { TripLayer } from './TripLayer.js';
import { SegmentsLayer } from './SegmentsLayer.js';

export function Map() {
  const tool = useContext(ToolsContext);
  let Layers = (<></>);

  switch (tool.name) {
    case 'stopsTool':
      Layers = <MarkerStopLayer></MarkerStopLayer>
    break;
    case 'routesTool':
      if (tool.propertyEditor) {
        Layers = <RoutePolylineLayer></RoutePolylineLayer>
      } else {
        Layers = <></>
      }
    break;
    case 'tripsTool':
      if(tool.selection) Layers = <TripLayer></TripLayer>
    break;
    case 'segmentsTool':
      Layers = <SegmentsLayer />
    break;
  };

  return (
    <MapContainer 
      center={[54.464441078, 17.020304345]} 
      zoom={13} 
      style={{ height: '89vh', width: '100%' }}
      preferCanvas={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {Layers}
      <MapContextMenu />
    </MapContainer>
  );
}

